// extracted by mini-css-extract-plugin
export default {"content":"ModernTabs_content__QcK8a","inactiveTab":"ModernTabs_inactiveTab__gMUv0"};